import {fromJS} from 'immutable';
import uid from 'uuid/v1';

export const defState = {
    page: 'cart', //cart, delivery, summary
    items: [],
    delivery_info: {
        name: '',
        phone: '',
        email: '',
        agreed: false,
        delivery: 'courier',
        address: '',
        city: '',
        postcode: '',
    },
    addToCartModal: false,
    mods: [
        {
            id: 1,
            title: 'Airbox',
            price: 15.99
        },
        {
            id: 1,
            title: 'Airbox Filter',
            price: 3.99
        }
    ]
};

export default function reducer(state = fromJS(defState), action) {
    switch (action.type) {
        case 'QUANTITY_CHANGE': {
            let {id, value} = action.payload;
            //console.log(id, value);
            if (value <= 0) {
                value = 1;
            }
            const index = state.get('items').findIndex(i => {
                return i.get('id') === id
            });
            return state.setIn(['items', index], state.getIn(['items', index]).set('quantity', value));
        }
        case 'CART_CHANGE_PAGE': {
            let {page} = action.payload;
            return state.set('page', page);
        }
        case 'CART_CHANGE_DELIVERY_INFO': {
            try {
                let {value, key} = action.payload;
                return state.setIn(['delivery_info', key], value);
            } catch (e) {
                console.warn('CART_CHANGE_DELIVERY_INFO, missing payload, skipping action');
                return state;
            }
        }
        case 'ADD_TO_CART': {
            return state.set('items', state.get('items').push(fromJS(action.payload)));
        }
        case 'REMOVE_FROM_CART': {
            const {id} = action.payload;
            return state.set('items', state.get('items').filter((item) => item.get('id') !== id));
        }
        case 'ADD_TO_CART_MODAL_OPEN': {
            return state.set('addToCartModal', fromJS(action.payload));
        }
        case 'ADD_TO_CART_MODAL_CLOSE': {
            return state.set('addToCartModal', false);
        }
        default:
            return state;
    }
};